import { useCallback } from 'react';

import { Text, ChakraProps } from '@chakra-ui/react';

import { languageData } from '@/config';

import { TranslationProps } from '../../../config/locale/type';
import { useAppSelector } from '../../../context/redux/store';

// todo: 모두 useTranslater로 변경 필요
export const useTranslater = () => {
  const { value } = useAppSelector((state) => state.language);
  const translate = useCallback(
    (data: TranslationProps) => {
      return data?.[value];
    },
    [value],
  );
  const translateGender = useCallback(
    (gender: string | undefined) => {
      if (!gender) {
        return '';
      }
      if (gender === 'F') {
        return translate(languageData.common.gender.F);
      }
      if (gender === 'M') {
        return translate(languageData.common.gender.M);
      }
      return translate(languageData.common.gender.O);
    },
    [translate],
  );

  const fullName = useCallback(
    (firstName: string | undefined, lastName: string | undefined) => {
      let name;
      const first = firstName || '';
      const last = lastName || '';
      if (value === 'ko') name = `${last}${first}`;
      else name = `${first} ${last}`;
      // Amy : 이름 성 모두 없을 경우 빈문자열 return
      if (name === ' ') return '';
      return name || '';
    },
    [value],
  );
  return { translate, translateGender, fullName, languageMode: value };
};

export const translate = (data: TranslationProps) => {
  // todo: 상세한 에러를 보기 위해 useTranslate나 Translate로 변경 필요
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { value } = useAppSelector((state) => state.language);
  return data?.[value];
};

export const useTranslate = (data: TranslationProps) => {
  const { value } = useAppSelector((state) => state.language);
  return data[value];
};

export const translater = (data: TranslationProps, value: string) => {
  return data[value];
};

export interface TranslateProps extends ChakraProps {
  data: TranslationProps;
  fallback?: string;
}

const Translate = ({ data, fallback, ...rest }: TranslateProps) => {
  const { value } = useAppSelector((state: { language: any }) => state.language);
  return (
    <Text as="span" {...rest}>
      {data?.[value] || fallback || ''}
    </Text>
  );
};

export default Translate;
